import moment from "moment";
import React, { useState } from "react";
import { isNullString } from "../../utils/Utils";

const OrdinaryProjectsCompleted = (props) => {
    return (
        <>
            {
                props.ordinaryProjectsCompletedList != null ?

                    < div className="board-of-directors ">
                        <table className="bborder border-[#11378a] w-full">
                            <tr className="bg-[#11378a] border border-[#11378a] text-white text-xl font-bold ">
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Developer License No.
                                </th>
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Name of Project
                                </th>
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Location of Project
                                </th>
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Date of TOP
                                </th>
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Type of Development
                                </th>
                            </tr>
                            <>
                                {
                                    props.ordinaryProjectsCompletedList.map((value, key) => {
                                        return (
                                            <React.Fragment key={key}>

                                                <tbody>
                                                    <tr className="border border-[#11378a]">
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            <span>{value.developerLicenseNo}</span>
                                                        </td>
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            <span>{value.projectName}</span>
                                                        </td>
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            <span>{value.projectLocation}</span>
                                                        </td>
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            {isNullString(value.dateOfTOP) === "" ? "-" :
                                                                <span>
                                                                    {moment(value.dateOfTOP).format("DD MMM YYYY")}
                                                                </span>
                                                            }
                                                        </td>
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            <span>{value.projectDevelopmentName}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </React.Fragment >
                                        )
                                    })
                                }
                            </>
                        </table>
                    </div >
                    : null
            }
            {
                props.ordinaryProjectsInCompleteList != null ?
                    < div className="board-of-directors">
                        <table className="bborder border-[#11378a] w-full">
                            <tr className="bg-[#11378a] border border-[#11378a] text-white text-xl font-bold ">
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Developer License No.
                                </th>
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Name of Project
                                </th>
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Location of Project
                                </th>
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Expected Date of Launch
                                </th>
                                <th className="whitespace-nowrap border text-center border-[#11378a] text-white py-2 md:px-5 px-2 w-[20%]">
                                    Type of Development
                                </th>
                            </tr>
                            <>
                                {
                                    props.ordinaryProjectsInCompleteList.map((value, key) => {
                                        return (
                                            <React.Fragment key={key}>

                                                <tbody>
                                                    <tr className="border border-[#11378a]">
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            <span>{value.developerLicenseNo}</span>
                                                        </td>
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            <span>{value.projectName}</span>
                                                        </td>
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            <span>{value.projectLocation}</span>
                                                        </td>
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            {isNullString(value.dateOfTOP) === "" ? "-" :
                                                                <span>
                                                                    {moment(value.dateOfTOP).format("DD MMM YYYY")}
                                                                </span>
                                                            }
                                                        </td>
                                                        <td className="whitespace-nowrap border bg-[#e9e9e9] border-[#11378a] text-center text-lg py-2 md:px-2 px-2 w-[33.333%]">
                                                            <span>{value.projectDevelopmentName}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </React.Fragment >
                                        )
                                    })
                                }
                            </>
                        </table>
                    </div >
                    : null
            }
        </>
    );
};

export default OrdinaryProjectsCompleted;